<template>
  <header class="rx-header">
    <router-link class="rx-brand" to="/" aria-label="리치고 Expert 홈"><img class="rx-brand-logo" src="../assets/header/richgo_expert_logo.svg" alt="리치고 Expert" width="212" height="49" /></router-link>
    <nav class="rx-primary-nav" aria-label="주 메뉴"><router-link to="/realestate">분석 홈</router-link><router-link to="/insight">통합 차트 <small>BETA</small></router-link><router-link to="/economy">경제 분석</router-link><router-link to="/service">서비스 소개</router-link><details ref="help" class="rx-help-menu" @keydown.esc.prevent.stop="closeHelp(true)" @focusout="onHelpFocusOut"><summary ref="helpSummary">도움말</summary><div><router-link to="/pricing">요금안내</router-link><a href="https://dataknows.notion.site/Expert-835e26b0d8784052a6cdc7b5492175df" target="_blank" rel="noopener noreferrer">사용방법 안내 ↗</a><a href="https://richgo.channel.io/lounge?service=expert" target="_blank" rel="noopener noreferrer">고객센터 ↗</a><a href="https://www.richgolab.com" target="_blank" rel="noopener noreferrer">부동산 상담 ↗</a><router-link v-if="$store.state.profile && $store.state.profile.isHyundai" to="/hyundai">현대건설 서비스</router-link><router-link v-if="$store.state.profile && $store.state.profile.isDlcon" to="/dlcon">DL 서비스</router-link></div></details></nav>
    <div class="rx-account"><router-link :to="$store.state.isLoggedin ? '/profile' : '/login'">{{ $store.state.isLoggedin ? '내 계정' : '로그인' }}</router-link><button v-if="$store.state.isLoggedin" @click="onLogout">로그아웃</button><router-link v-else class="rx-small-primary" to="/signup">회원가입</router-link></div>
  </header>
</template>
<script>
export default {
  async created() { await this.$store.dispatch('updateLoggedin'); },
  async updated() { await this.$store.dispatch('updateLoggedin'); },
  mounted() { document.addEventListener('pointerdown', this.onOutsidePointer, true); },
  beforeDestroy() { document.removeEventListener('pointerdown', this.onOutsidePointer, true); },
  watch: { '$route.fullPath'() { this.closeHelp(); } },
  methods: {
    closeHelp(restoreFocus = false) {
      if (this.$refs.help) this.$refs.help.open = false;
      if (restoreFocus && this.$refs.helpSummary) this.$refs.helpSummary.focus();
    },
    onHelpFocusOut(event) {
      const help = this.$refs.help;
      if (help && help.open && !help.contains(event.relatedTarget)) this.closeHelp();
    },
    onOutsidePointer(event) {
      const help = this.$refs.help;
      if (help && help.open && !help.contains(event.target)) this.closeHelp();
    },
    async onLogout() {
      this.$store.commit('logout');
      if (this.$route.path !== '/') this.$router.push('/');
      await this.$store.dispatch('updateLoggedin');
    }
  }
};
</script>

<style>@import "./header.css";</style>
